import { render, staticRenderFns } from "./PersonalizedSites.vue?vue&type=template&id=530ee4b6&scoped=true&"
import script from "./PersonalizedSites.vue?vue&type=script&lang=js&"
export * from "./PersonalizedSites.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/personalized-sites.css?vue&type=style&index=0&lang=css&"
import style1 from "./PersonalizedSites.vue?vue&type=style&index=1&id=530ee4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ee4b6",
  null
  
)

export default component.exports